export { default as getAppIcon } from './getAppIcon';
